import { render, staticRenderFns } from "./Topic.vue?vue&type=template&id=87b4728a"
import script from "./Topic.vue?vue&type=script&lang=js"
export * from "./Topic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87b4728a')) {
      api.createRecord('87b4728a', component.options)
    } else {
      api.reload('87b4728a', component.options)
    }
    module.hot.accept("./Topic.vue?vue&type=template&id=87b4728a", function () {
      api.rerender('87b4728a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/community/Topic.vue"
export default component.exports